import { EmptyState } from '@/ui'
import { BackLink } from './BackLink'
import { TopBar } from './TopBar'
import type { PageProps } from './ClientRoutes'

export function GalleriesPage({ client, base }: Omit<PageProps, 'config'>) {
  return (
    <>
      <TopBar clientName={client.name} section="Galleries" homeHref={base} />
      <main id="main" className="mx-auto grid w-full max-w-portal gap-8 px-6 py-section-sm md:px-10">
        <div>
          <BackLink fallback={base} />
        </div>
        <EmptyState eyebrow="Galleries" title="Your galleries will live here.">Photos and video from each shoot, ready to download and share, arrive after the first session.</EmptyState>
      </main>
    </>
  )
}
